<template>
  <div class="page-body user-profile v-assets-setting">
    <b-row no-gutters>
      <b-col md="12">

        <b-card class="data-card" :show-footer-line="true">
          <div class="mb-4 d-flex align-items-center justify-content-between flex-column">
            <div class=" d-flex align-items-center justify-content-between mb-2 w-100">
              <h3 class="text-right ">
                لیست ووچر ها
              </h3>
              <b-button
                v-if="isSuperAdmin"
                variant="primary"
                @click="$bvModal.show('new-voucher')">
                ایجاد ووچر جدید
              </b-button>
            </div>

            <div class="d-flex align-items-center justify-content-start w-100">
              <b-input
                @input="searchByGroupName($event)"
                style="width: 450px"
                placeholder="جستجو بر اساس نام گروه..."
              />
            </div>
          </div>
          <b-row no-gutters>
            <b-col no-gutters lg="12" sm="12" class="right-section">
              <!-- Main table element -->
              <b-overlay
                class="v-asset-profile__overlay"
                :show="vouchers.loading"
                rounded="sm"
              >
                <b-table
                  :items="vouchers.items"
                  :fields="vouchers.fields"
                  :current-page="vouchers.filters.page"
                  :per-page="vouchers.filters.perPage"
                  stacked="md"
                  empty-text="موردی یافت نشد"
                  show-empty
                >
                  <template #cell(actions)="row" v-if="isSuperAdmin">
                    <b-button
                      size="sm"
                      @click="editVoucherItem(row.item)"
                      variant="primary"
                    >
                      ویرایش
                    </b-button>
                  </template>

                </b-table>

                <b-row no-gutters>
                  <b-col sm="12" class="my-1 d-flex justify-content-center">
                    <BasePagination
                      @onClick="fetchData({page:vouchers.filters.page +1})"
                    />
                  </b-col>
                </b-row>

                <template #overlay>
                  <div class="text-center">
                    <b-icon
                      icon="stopwatch"
                      font-scale="3"
                      animation="cylon"
                    ></b-icon>
                    <p id="cancel-label">در حال بارگزاری...</p>
                  </div>
                </template>

              </b-overlay>
            </b-col>
          </b-row>
        </b-card>
        <br/>
      </b-col>
    </b-row>


    <b-modal
      title="ایجاد ووچر جدید"
      :hide-footer="true"
      id="new-voucher">
      <div>
        <label
          class="text-right w-100"
          for="groupName">
          نام گروه ووچر
        </label>
        <b-form-input
          id="groupName"
          v-model="newVoucher.groupName"
        />
      </div>
      <div class="mt-4">
        <label
          class="text-right w-100"
          for="count">
          تعداد
        </label>
        <b-form-input
          id="count"
          type="number"
          v-model="newVoucher.count"
        />
      </div>
      <div class="mt-4">
        <label
          class="text-right w-100"
          for="usableCount">
          تعداد قابل استفاده
        </label>
        <b-form-input
          id="usableCount"
          type="number"
          v-model="newVoucher.usableCount"
        />
      </div>


      <div class="d-flex align-items-center justify-content-between mt-4">
        <base-button
          :loading="newVoucher.loading"
          @click="submitNewVoucher"
          type="success">
          ذخیره
        </base-button>
      </div>

    </b-modal>

    <b-modal
      title="لیست کد های ووچر ایجاد شده"
      :hide-footer="true"
      id="vouchers">

      <div class="bg-secondary p-3">
        <ul class="vouchers-list">
          <li v-for="(item,i) in voucherCodes" :key="i">
            {{ item }}
          </li>
        </ul>
      </div>

    </b-modal>

    <b-modal
      title="ویرایش ووچر "
      :hide-footer="true"
      id="edit-voucher">
      <div class="mt-4">
        <label
          class="text-right w-100"
          for="usableCount">
          تعداد قابل استفاده
        </label>
        <b-form-input
          id="usableCount"
          type="number"
          v-model="editVoucher.remainingCount"
        />
      </div>


      <div class="d-flex align-items-center justify-content-between mt-4">
        <base-button
          :loading="editVoucher.loading"
          @click="updateVoucher"
          type="success">
          ذخیره
        </base-button>
      </div>

    </b-modal>

  </div>
</template>

<script>
import CryptoIcons from "@/components/CryptoIcons";
import {fetchVouchers, storeVoucher, updateVoucher} from "@/httpservices/voucher";
import _ from 'lodash';
import BasePagination from "@/components/BasePagination.vue";


export default {
  name: "voucher-setting",

  components: {
    CryptoIcons,
    BasePagination
  },


  data() {
    return {
      vouchers: {
        filters: {
          page: 0,
          perPage: 25,
          groupName: '',
        },
        fields: [
          {
            key: "groupName",
            label: "نام گروه",
            sortDirection: "asc",
            class: "text-right",
          },
          {
            key: "voucher",
            label: "نام ووچر",
            sortDirection: "asc",
            class: "text-right",
          },
          {
            key: "createdCount",
            label: "تعداد اولیه",
            sortable: false,
            class: "text-center",
          },
          {
            key: "remainingCount",
            label: "تعداد باقی مانده",
            sortable: false,
            class: "text-center",
          },
          {key: "actions", label: "عملیات"},
        ],
        items: [],
        loading: true,
        totalCount: 0,
      },
      newVoucher: {
        loading: false,
        groupName: "",
        usableCount: "",
        count: ""
      },
      editVoucher: {
        loading: false,
        groupName: "",
        voucher: "",
        createdCount: "",
        remainingCount: ""
      },
      voucherCodes: [],
    }
  },

  computed: {
    isSuperAdmin() {
      return this.$store['getters'].isSuperAdmin;
    }
  },

  methods: {
    async updateVoucher() {
      this.editVoucher.loading = true;
      try {
        await updateVoucher({
          voucher: this.editVoucher.voucher,
          usableCount: this.editVoucher.remainingCount
        });
        this.$swal({
          position: "center",
          icon: "success",
          title: 'با موفقیت ویرایش شد',
          showConfirmButton: false,
        });
        await this.fetchData();
      } catch (e) {
        console.log({e})
      }
      this.editVoucher.loading = false;
      this.$bvModal.hide('edit-voucher');
    },
    async submitNewVoucher() {
      this.newVoucher.loading = true;
      try {
        const res = await storeVoucher(this.newVoucher);
        this.voucherCodes = res.data.map(item => item.voucher);
        this.$swal({
          position: "center",
          icon: "success",
          title: 'با موفقیت ایجاد شد',
          showConfirmButton: false,
        });
        this.$bvModal.show('vouchers');
        await this.fetchData();
      } catch (e) {
        console.log(e)
      }
      this.newVoucher.loading = false;
      this.$bvModal.hide('new-voucher');
    },
    async fetchData(filters = {}) {
      this.vouchers.loading = true;
      this.vouchers.filters = {
        ...filters,
        ...this.vouchers.filters,
      }
      try {
        this.vouchers.items = (await fetchVouchers(this.vouchers.filters)).data || [];
        this.vouchers.totalCount = this.vouchers.items.length;
      } catch (e) {
        console.log({e})
      }
      this.vouchers.loading = false;
    },
    editVoucherItem(item) {
      this.$bvModal.show('edit-voucher');
      this.editVoucher = {
        ...this.editVoucher,
        loading: false,
        groupName: item.groupName,
        voucher: item.voucher,
        createdCount: item.createdCount,
        remainingCount: item.remainingCount,
      }
      this.$bvModal.hide('edit-voucher');
    },
    searchByGroupName: _.throttle(function (value) {
      this.vouchers.filters.groupName = value;
      this.fetchData();
    }, 600),
    copyToClipboard(text) {
      const dummy = document.createElement("textarea");
      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);
    }
  },

  mounted() {
    this.fetchData();
  }
};

</script>

<style lang="scss">
.modal-header .close {
  padding: 0;
  margin: 0;
}

.vouchers-list {
  padding: 0;
  list-style-type: none;
  margin: 0;
  text-align: left;
}

.vouchers-list li {
  padding: 2px 0;
}
</style>
